// https://github.com/turbolinks/turbolinks#installation-using-npm
import Turbolinks from "turbolinks";

Turbolinks.start();
